import { useState, useCallback } from 'react';

export default function useGridSections() {
  const [expandedSections, setExpandedSections] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('maestro_grid_sections') || '{}'); } catch { return {}; }
  });

  const toggleSection = useCallback((key) => {
    setExpandedSections((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      try { sessionStorage.setItem('maestro_grid_sections', JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  }, []);

  return { expandedSections, toggleSection };
}
